// 获取商品列表
const GETPRODUCTLIST = 'GETPRODUCTLIST';

export default GETPRODUCTLIST;
